/* eslint-disable no-nested-ternary */
import React from 'react';
import { FormApi } from 'final-form';
import Input, { AmountInput, Select, SelectItem, InputWithButton } from 'ui/Input';
import { IGhanaPaymentsState, IFormValues, Steps } from './GhanaGov.model';

export const renderServiceName = (services: IGhanaPaymentsState['serviceName'], submitting: boolean) => (
  <Select name="serviceName" label="Service Name" disabled={submitting}>
    {services.map(({ name, code, id }) => (
      <SelectItem value={code} key={id}>
        {name}
      </SelectItem>
    ))}
  </Select>
);

export const renderInvoiceField = (
  submitting: boolean,
  values: IFormValues,
  step: Steps,
  onBtnClick: (values) => void,
) => (
  <>
    <InputWithButton
      name="invoice"
      label="Invoice/Advice/Reference Number"
      disabled={submitting || step === Steps.PROCEED}
      onBtnClick={() => onBtnClick(values)}
      disabledButton={!values.serviceName}
      isShowBtn={step === Steps.VERIFY}
      btnTxt="Generate"
    />
  </>
);

export const renderInvoiceDescriptionField = () => (
  <>
    <Input name="invoiceDescription" label="Invoice Description" disabled />
  </>
);

export const renderCreatedDateField = () => (
  <>
    <Input name="createdDate" label="Created Date" disabled />
  </>
);

export const renderExpiryDateField = () => (
  <>
    <Input name="expiryDate" label="Expiry Date" disabled />
  </>
);

export const renderInvoiceStatusField = () => (
  <>
    <Input name="invoiceStatus" label="Invoice Status" disabled />
  </>
);

export const renderCustomerNameField = () => (
  <>
    <Input name="customerName" label="Customer Name" disabled />
  </>
);

export const renderSourceAccountFieldSelect = (accounts: IGhanaPaymentsState['accounts'], submitting: boolean) => (
  <Select name="sourceAccount" label="Source Account" disabled={submitting}>
    {accounts.map(({ accountNumber }) => (
      <SelectItem value={accountNumber} key={accountNumber}>
        {accountNumber}
      </SelectItem>
    ))}
  </Select>
);

export const renderSourceAccountFieldInput = () => (
  <>
    <Input name="sourceAccount" label="Source Account" disabled />
  </>
);

export const renderNarrationField = () => (
  <>
    <Input name="narration" label="Narration" disabled />
  </>
);

export const renderAmountField = (currency: string) => (
  <AmountInput currency={currency} name="amount" label="Amount" disabled />
);

const renderGhanaPaymentsFields = (
  values: IFormValues,
  form: FormApi<IFormValues>,
  state: IGhanaPaymentsState,
  submitting: boolean,
  step: Steps,
  onBtnClick,
) => {
  if (state.accounts.length === 1) {
    form.mutators.changeFieldValue('sourceAccount', state.accounts[0].accountNumber);
  }
  const fields = (
    <>
      {step === Steps.VERIFY ? renderServiceName(state.serviceName, submitting) : null}
      {step === Steps.PROCEED
        ? state.accounts.length > 1
          ? renderSourceAccountFieldSelect(state.accounts, submitting)
          : renderSourceAccountFieldInput()
        : null}

      {renderInvoiceField(submitting, values, step, onBtnClick)}
      {step === Steps.PROCEED ? (
        <>
          {renderInvoiceDescriptionField()}
          {renderCreatedDateField()}
          {renderExpiryDateField()}
          {renderInvoiceStatusField()}
          {renderCustomerNameField()}
          {renderNarrationField()}
          {renderAmountField(state.currency)}
        </>
      ) : null}
    </>
  );
  return fields;
};

export default renderGhanaPaymentsFields;
